
import BusRatesTable from './BusRatesTable';
import { Link } from "react-router-dom";
import './smallkey.css';
import SEO from "../components/SEO";
import LocalBusinessSchema from "../components/LocalBusinessSchema";
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Seaterfive() {



    const cardData =
    {
        keyword: '25 Seater Bus On Rent in Pune',
        heading: 'Amruta Travels: 25 Seater Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 25 Seater Bus On Rent in Pune, providing a reliable and comfortable transportation solution for your group travel needs. Whether you are organizing a family outing, corporate event, school trip, or pilgrimage, our well-maintained 25-seater buses ensure a smooth and enjoyable journey. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Pune simple and stress-free. Book your 25-seater bus with Amruta Travels and embark on a journey of comfort and convenience!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


 "services": [
    {
      "name": "25 Seater Bus On Rent in Pune",
      "description": "Amruta Travels provides 25 seater buses on rent in Pune, ideal for medium-sized groups looking for a balance of comfort and affordability. Suitable for weddings, tours, corporate events, and religious trips, the buses are maintained for safety and reliability."
    },
    {
      "name": "25 Seater Bus Hire in Pune",
      "description": "Hire a 25-seater bus in Pune with Amruta Travels for your group travel needs. Our well-equipped buses ensure comfort and are operated by trained drivers for a smooth journey within Pune or to outstation destinations."
    },
    {
      "name": "25 Seater Bus Rate Per Km Pune",
      "description": "We offer transparent and competitive per kilometer rates for 25 seater bus rentals in Pune. Whether it's a one-day trip or a long-distance tour, get customized pricing based on your route and travel requirements."
    },
    {
      "name": "25 Seater Bus On Rent in Pune with Driver",
      "description": "Amruta Travels provides 25 seater buses on rent in Pune along with professional drivers who are experienced, courteous, and knowledgeable about regional routes. Sit back and relax while we handle the journey."
    },
    {
      "name": "Pune to Mahabaleshwar 25 Seater Bus On Rent",
      "description": "Plan your scenic getaway to Mahabaleshwar with our 25 seater bus rental service. Our buses ensure a comfortable journey through the ghats, making them perfect for families, schools, or corporate groups."
    },
    {
      "name": "Pune to Goa 25 Seater Bus On Rent",
      "description": "Heading to Goa from Pune? Amruta Travels offers 25 seater buses for group trips to Goa, equipped with AC, reclining seats, and luggage space—ideal for weekend getaways or extended stays at the beach."
    },
    {
      "name": "Pune to Nashik 25 Seater Bus On Rent",
      "description": "Travel comfortably from Pune to Nashik with our 25-seater bus rental services. Enjoy the ride to this historic and spiritual destination with amenities like air conditioning, clean interiors, and punctual service."
    },
    {
      "name": "Pune to Bhimashankar 25 Seater Bus On Rent",
      "description": "Book a 25 seater bus from Pune to Bhimashankar for darshan or weekend treks. Our buses are ideal for family groups or office teams planning a spiritual or nature-focused trip."
    },
    {
      "name": "Pune to Ashtavinayak Darshan 25 Seater Bus On Rent",
      "description": "Embark on the sacred Ashtavinayak Yatra in comfort with a 25-seater bus from Amruta Travels. The bus includes all essential facilities and a knowledgeable driver for temple routes across Maharashtra."
    },
    {
      "name": "Pune to Alibag 25 Seater Bus On Rent",
      "description": "Planning a beachside escape to Alibag? Our 25-seater buses are perfect for group travel to coastal destinations. Enjoy the sea breeze and a hassle-free ride with Amruta Travels."
    },
    {
      "name": "Pune to Kolhapur 25 Seater Bus On Rent",
      "description": "Book a 25 seater bus from Pune to Kolhapur for religious tours, family visits, or business travel. Our buses are well-maintained and provide a smooth ride through highways and cities."
    },
    {
      "name": "25 Seater Bus On Rent for Corporate Event",
      "description": "Amruta Travels offers 25-seater bus rental for corporate events in Pune. From offsite meetings to team outings, our buses provide timely pickups, comfortable seating, and professional drivers."
    },
    {
      "name": "25 Seater Bus Rate Per Km Pune",
      "description": "Our pricing for 25 seater buses in Pune is flexible and based on per kilometer rates, with options for hourly rentals and outstation bookings. Contact us for a customized quote that fits your travel plan and budget."
    },
    {
      "name": "25 Seater Bus On Rent for Marriage in Pune",
      "description": "Need transportation for your wedding guests? Rent a 25 seater bus in Pune with Amruta Travels for seamless guest transfers. Spacious, comfortable, and stylish, our buses ensure a memorable wedding experience."
    }
  ],
  "tableData": [
    ["25 Seater Bus On Rent in Pune", "25 Seater Bus Hire in Pune"],
    ["25 Seater Bus Rate Per Km Pune", "25 Seater Bus On Rent in Pune with Driver"],
    ["Pune to Mahabaleshwar 25 Seater Bus On Rent", "Pune to Goa 25 Seater Bus On Rent"],
    ["Pune to Nashik 25 Seater Bus On Rent", "Pune to Bhimashankar 25 Seater Bus On Rent"],
    ["Pune to Ashtavinayak Darshan 25 Seater Bus On Rent", "Pune to Alibag 25 Seater Bus On Rent"],
    ["Pune to Kolhapur 25 Seater Bus On Rent", "25 Seater Bus On Rent for Corporate Event"],
    ["25 Seater Bus Rate Per Km Pune", "25 Seater Bus On Rent for Marriage in Pune"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Versatile 25 Seater Bus Rental in Pune",
    "WhyChoosedescription": "Amruta Travels offers reliable and comfortable 25 seater bus rental services in Pune, ideal for mid-sized groups traveling together. Whether it’s a corporate outing, school trip, family function, or outstation tour, our 25-seater buses provide the right balance of space, comfort, and affordability for seamless group travel."
  },
  {
    "WhyChooseheading": "Perfect for Events, Picnics, and Local City Tours",
    "WhyChoosedescription": "Our 25 seater buses are well-suited for group events such as weddings, employee transportation, social gatherings, or local sightseeing tours in Pune. With sufficient seating capacity, legroom, and luggage space, your group can enjoy a coordinated and relaxed journey without the stress of multiple vehicles."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Interiors",
    "WhyChoosedescription": "Each 25-seater bus is equipped with push-back seats, clean upholstery, ample headspace, and proper ventilation. AC and Non-AC options are available based on your comfort preferences. Our buses are sanitized before every trip and undergo regular maintenance to ensure a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Local and Outstation Routes",
    "WhyChoosedescription": "Our professional drivers are courteous, punctual, and experienced in both city and highway routes. Whether your destination is within Pune or outstation like Lonavala, Shirdi, Mahabaleshwar, or Mumbai, they ensure a timely and safe ride for your group. Drivers are familiar with traffic patterns and prioritize passenger safety."
  },
  {
    "WhyChooseheading": "Flexible Booking and Custom Itinerary Options",
    "WhyChoosedescription": "We offer customizable travel plans that match your group’s schedule. Choose from half-day, full-day, or multi-day rentals. Need multiple pickup points, early morning departures, or return late at night? We’re flexible and fully equipped to match your needs with precise planning and coordination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive pricing for 25 seater bus rentals in Pune with no hidden charges. All-inclusive packages cover driver fees, fuel, tolls, and taxes. Our transparent quotes help you plan your trip budget effectively—ideal for schools, corporates, families, and travel agencies."
  },
  {
    "WhyChooseheading": "Ideal for Mid-Sized Groups and Safe Group Travel",
    "WhyChoosedescription": "The 25 seater bus is a perfect choice when you need a vehicle larger than a tempo traveller but smaller than a full coach. It’s best for medium groups looking for economical, coordinated transport. We ensure seatbelt-equipped buses and adhere to all safety and hygiene protocols."
  },
  {
    "WhyChooseheading": "Simple Booking Process with 24/7 Assistance",
    "WhyChoosedescription": "Booking a 25 seater bus in Pune is quick and hassle-free. You can reserve online, via call, or by visiting our office. Our team offers round-the-clock customer support, helping you with scheduling, route planning, and any last-minute changes during your journey."
  }
]














    }

const faqData = [
  {
    question: 'Can I rent a 25 seater bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 25 seater buses on rent in Pune for various purposes including corporate trips, family outings, weddings, and school excursions.',
  },
  {
    question: 'What are the features of the 25 seater bus?',
    answer: 'Our 25 seater buses are equipped with push-back seats, air conditioning (optional), clean interiors, ample legroom, and luggage storage, offering a comfortable ride for mid-sized groups.',
  },
  {
    question: 'Is the 25 seater bus available for outstation trips from Pune?',
    answer: 'Absolutely. Our 25 seater buses are ideal for outstation trips to destinations like Mahabaleshwar, Lonavala, Shirdi, Nashik, Goa, and more.',
  },
  {
    question: 'Can I book the 25 seater bus for local use within Pune?',
    answer: 'Yes, the 25 seater bus is available for local travel within Pune for events, city tours, employee transport, and family functions.',
  },
  {
    question: 'Is the 25 seater bus suitable for airport transfers?',
    answer: 'Yes, our 25 seater bus is perfect for group airport pickups and drops. It has enough space for passengers and their luggage, ensuring hassle-free transfers.',
  },
  {
    question: 'Do you provide a driver with the 25 seater bus rental?',
    answer: 'Yes, all our buses come with experienced, licensed drivers who ensure a safe, smooth, and punctual journey.',
  },
  {
    question: 'How much does it cost to rent a 25 seater bus in Pune?',
    answer: 'The cost depends on factors such as distance, duration, and type of trip (local or outstation). Please contact us with your travel details for a customized and transparent quote.',
  },
  {
    question: 'Can I rent the 25 seater bus for a wedding or private event?',
    answer: 'Definitely! Our 25 seater bus is commonly hired for wedding guest transport, family functions, and private celebrations in and around Pune.',
  },
  {
    question: 'Why choose Amruta Travels for 25 seater bus rental?',
    answer: 'Amruta Travels offers well-maintained vehicles, professional drivers, punctual service, and flexible rental options—all backed by excellent customer support.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Shinde',
    role: 'Business Owner, Pune',
    text: 'We rented a 25 seater bus from Amruta Travels for a client meeting out of town. The bus was clean, the ride was smooth, and the driver was punctual. Excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sheetal Desai',
    role: 'Event Organizer',
    text: 'Amruta Travels provided a 25 seater bus for our family event. Everything went perfectly—from pickup to drop-off. The comfort and professionalism were top-notch.',
    rating: 5,
  },
];







































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
    {
        src: "/images/gallery/24.jpg",
        alt: "25 Seater AC Bus Hire in Pune"
    },
    {
        src: "/images/gallery/28.jpg",
        alt: "Luxury 25 Seater Bus Rental Pune"
    },
    {
        src: "/images/gallery/2.jpg",
        alt: "Corporate 25 Seater Bus Hire Pune"
    },
    {
        src: "/images/gallery/3.jpg",
        alt: "Wedding 25 Seater Bus Hire Pune"
    },
    {
        src: "/images/gallery/24.jpg",
        alt: "25 Seater Tourist Bus Rental Pune"
    },
    {
        src: "/images/gallery/27.jpg",
        alt: "Outstation 25 Seater Bus Hire Pune"
    },
    {
        src: "/images/gallery/29.jpg",
        alt: "School Trip 25 Seater Bus Rental Pune"
    },
    {
        src: "/images/gallery/30.jpg",
        alt: "Employee Transport 25 Seater Bus Pune"
    },
    {
        src: "/images/gallery/31.jpg",
        alt: "Amruta Travels 25 Seater Bus Fleet Pune"
    },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",

  "serviceType": "25 Seater Bus On Rent in Pune",

  "name": "25 Seater Bus on Rent in Pune",

  "provider": {
    "@type": "TravelAgency",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },

  "image": "https://bushireinpune.com/images/keyword/63.jpg",

  "description": "Amruta Travels offers a 25 Seater Bus on Rent in Pune for corporate events, weddings, family trips, school excursions, airport transfers and outstation tours with experienced drivers.",

  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },

  "offers": {
  "@type": "Offer",
  "priceCurrency": "INR",
  "availability": "https://schema.org/InStock",
  "url": "https://bushireinpune.com/25-seater-bus-on-rent-in-pune"
}
};
const faqSchema = {
  "@context":"https://schema.org",
  "@type":"FAQPage",
  "mainEntity":faqData.map((faq)=>({
      "@type":"Question",
      "name":faq.question,
      "acceptedAnswer":{
          "@type":"Answer",
          "text":faq.answer
      }
  }))
}

const breadcrumbSchema = {
  "@context":"https://schema.org",
  "@type":"BreadcrumbList",
  "itemListElement":[
    {
      "@type":"ListItem",
      "position":1,
      "name":"Home",
      "item":"https://bushireinpune.com/"
    },
    {
      "@type":"ListItem",
      "position":2,
      "name":"Bus on Rent in Pune",
      "item":"https://bushireinpune.com/bus-on-rent-in-pune"
    },
    {
      "@type":"ListItem",
      "position":3,
      "name":"25 Seater Bus on Rent in Pune",
      "item":"https://bushireinpune.com/25-seater-bus-on-rent-in-pune"
    }
  ]
}

    return (
        <div>

<SEO
title="25 Seater Bus On Rent in Pune | AC Bus Hire | Amruta Travels"
description="Book a 25 Seater Bus On Rent in Pune with Amruta Travels. Perfect for weddings, corporate travel, family trips, airport transfers and outstation tours. Affordable rates with experienced drivers."
canonical="https://bushireinpune.com/25-seater-bus-on-rent-in-pune"
image="https://bushireinpune.com/images/keyword/63.jpg"
schema={[
productSchema,
faqSchema,
breadcrumbSchema
]}
/>

<LocalBusinessSchema />



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
25 Seater Bus On Rent in Pune
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="bus-rental" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="bus-rental-content">
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
src="/images/keyword/63.jpg"
alt="25 Seater Bus On Rent in Pune by Amruta Travels"
loading="eager"
fetchPriority="high"
width="900"
height="500"
/>
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />
<div className="my-5">
<h2>25 Seater Bus Specifications</h2>

<table className="table table-bordered">
<tbody>

<tr>
<th>Seating Capacity</th>
<td>25 Passengers</td>
</tr>

<tr>
<th>Air Conditioning</th>
<td>Available</td>
</tr>

<tr>
<th>Pushback Seats</th>
<td>Available</td>
</tr>

<tr>
<th>Music System</th>
<td>Available</td>
</tr>

<tr>
<th>Charging Points</th>
<td>Available</td>
</tr>

<tr>
<th>Luggage Space</th>
<td>Large</td>
</tr>

<tr>
<th>Driver Included</th>
<td>Yes</td>
</tr>

<tr>
<th>Suitable For</th>
<td>Corporate, Wedding, Tourism, School Trips, Family Tours</td>
</tr>

</tbody>
</table>
</div>
<h2>Related Bus Rental Services</h2>

<ul>
<li><Link to="/22-seater-bus-on-rent-in-pune">22 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/24-seater-bus-on-rent-in-pune">24 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/26-seater-bus-on-rent-in-pune">26 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/32-seater-bus-on-rent-in-pune">32 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/35-seater-bus-on-rent-in-pune">35 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/40-seater-bus-on-rent-in-pune">40 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/45-seater-bus-on-rent-in-pune">45 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/49-seater-bus-on-rent-in-pune">49 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/50-seater-bus-on-rent-in-pune">50 Seater Bus On Rent in Pune</Link></li>

<li><Link to="/53-seater-bus-on-rent-in-pune">53 Seater Bus On Rent in Pune</Link></li>
</ul>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>

<h2>People Also Search For</h2>

<ul>
    <li><Link to="/17-seater-bus-on-rent-in-pune">17 Seater Bus On Rent in Pune</Link></li>

    <li><Link to="/20-seater-bus-on-rent-in-pune">20 Seater Bus On Rent in Pune</Link></li>

    <li><Link to="/22-seater-bus-on-rent-in-pune">22 Seater Bus On Rent in Pune</Link></li>

    <li><Link to="/26-seater-bus-on-rent-in-pune">26 Seater Bus On Rent in Pune</Link></li>

    <li><Link to="/tempo-traveller-hire-in-pune">Tempo Traveller Hire in Pune</Link></li>

    <li><Link to="/mini-bus-on-rent-in-pune">Mini Bus On Rent in Pune</Link></li>

    <li><Link to="/bus-on-rent-in-pune">Bus On Rent in Pune</Link></li>
</ul>
                            <div
id="faq-section"
className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <Link
to="/bus-on-rent-in-pune"
className="d-flex justify-content-around align-items-center"
>
                                            <div className="b1">
                                                <img
src={e.place}
alt={e.text}
loading="lazy"
decoding="async"
width="120"
height="90"
/>
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <span className="px-3">
{e.text}
</span>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
src={image.src}
alt={image.alt}
className="gallery-image"
loading="lazy"
decoding="async"
width="300"
height="200"
/>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Seaterfive;